module.exports = __webpack_public_path__ + "static/img/list-bg-4.feb9a1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology/list-bg-4.png
// module id = ydYT
// module chunks = 1